import { render, staticRenderFns } from "./TitleText.vue?vue&type=template&id=9561a82a&"
import script from "./TitleText.vue?vue&type=script&lang=js&"
export * from "./TitleText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports